import { SkeletonBox } from '@billy/design-system'

import { useVatDeclaration } from '../../../../../../../context/vatDeclarationContext'
import { Section } from '../Section'
import * as Styled from './styles'

export const ReportContent = () => {
  const { report } = useVatDeclaration()

  return (
    <Styled.ReportContentWrapper>
      {report ? (
        report.map((reportSegment) => (
          <Section
            reportSegment={reportSegment}
            key={reportSegment?.symbol ? `${reportSegment?.symbol}-${reportSegment?.name}` : reportSegment.name}
          />
        ))
      ) : (
        <Styled.PreviewSkeletonWrapper>
          <SkeletonBox fullWidth />
        </Styled.PreviewSkeletonWrapper>
      )}
    </Styled.ReportContentWrapper>
  )
}
